import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { HeroBackground, HeroContentWrapper, HeroSection } from './Hero.styles';
import HeroContent from './HeroContent';

type OwnProps = {
  isLoggedIn?: boolean;
};

export default function Hero({ isLoggedIn }: OwnProps) {
  return (
    <Section
      as={HeroSection}
      eventName={ANALYTICS_EVENTS.MARKETING.SECTION_VIEWED_HERO}
    >
      <HeroBackground />
      <HeroContentWrapper>
        <HeroContent isLoggedIn={isLoggedIn} />
      </HeroContentWrapper>
    </Section>
  );
}
